<template>
    <div id="the-way-wrapper" class="portfolio-page">
        <div id="the-way">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <FullWidthImageSlider :sliderImages="fullWidthSliderImages"/>
            <ImageAndTextPortfolio 
                :imageAndTextContent="imageAndTextContent"
            />
            <section class="">
                <video 
                src="/videos/millhouse.mp4" 
                loop
                autoplay
                muted
                class="w-100 d-block">
                </video>
            </section>
            <ImageAndTextPortfolio 
                :imageAndTextContent="secondImageAndTextContent"
            />
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <b-container>
                        <div class="">
                            <b-row>
                                <b-col lg="12" class="">
                                    <img src="/img/portfolio/millhouse/millhouse-coming-soon-sign.jpg" alt="Millhouse Coming Soon" class="w-100 d-block">
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - The Underground",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_theWay: null,
            textAnimation_theWay: null,
            textAnimation_theWay: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "project identity creation"
                },
                {
                    name: "print ad"
                },
                {
                    name: "brochure design"
                },
                {
                    name: "website design & development"
                },
                {
                    name: "website hosting & management"
                },
                {
                    name: "marketing & digital advertising"
                },
                {
                    name: "media planning"
                },
                {
                    name: "interior design & decor consulting"
                },
                {
                    name: "signage design"
                },
                {
                    name: "production & installation"
                }
            ],
            pageName: "The Millhouse Condos",
            pageLink: "",
            linkName: "",
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/millhouse/millhouse-fullwidth-slider-1.jpg",
                    alt: "Millhouse"
                },
                {
                    img: "/img/portfolio/millhouse/millhouse-fullwidth-slider-2.jpg",
                    alt: "Millhouse"
                },
                {
                    img: "/img/portfolio/millhouse/millhouse-fullwidth-slider-3.jpg",
                    alt: "Millhouse"
                },
                {
                    img: "/img/portfolio/millhouse/millhouse-fullwidth-slider-4.jpg",
                    alt: "Millhouse"
                },
            ],
            firstSliderStyles: {
                bgColor: '#d7b140',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: 'DECO CONCIERGE'
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-way-apologies.jpg",
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-way-apologies.jpg",
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                imgOnLeftSide: false,
                heading: "GORILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: 'DECO CONCIERGE'
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "GORILLA MARKETING CAMPAIGN",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                bgColor: '#e15f60',
                bgImageClass: false,
                otherSideBgClass: "stipple-bg",
                textColor: "#000",
                imgPadding: false,
                img: "/img/portfolio/millhouse/millhouse-half.jpg",
                alt: "Millhouse",
                heading: "PRESENTATION CENTRE",
                desc: "The Millhouse is a trilogy of three towers that are redefining condo living in downtown Milton. It combines the best parts of aspirational living with Milton's beloved natural lifestyle to give residents the best of both worlds. 1063 Created an immersive presentation centre that invited potential homebuyers to experience all The Millhouse had to offer. From a complete scale model of the community to changing digital displays, large-scale amenity maps, detailed renderings, and more, this comprehensive sales space was integral to the community's impressive success."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                bgColor: "#000",
                bgImageClass: false,
                otherSideBgClass: false,
                textColor: "#fff",
                imgPadding: false,
                img: "/img/portfolio/millhouse/millhouse-half-2.jpg",
                alt: "Millhouse Booklet",
                heading: "BROCHURE",
                desc: "The strength of 1063's creative team is on full display inside The Millhouse brochure. Beautiful imagery and informative copy fill every page of this crucial deliverable, turning it from a simple sales tool into a true showpiece. The brochure takes readers on a journey throughout the city of Milton, the stunning natural spaces surrounding it, and into the condominium itself for an extensive look into life at The Millhouse. We considered every design detail to paint an eloquent portrait of Milton's most exciting new home opportunity to-date."
            },
            nextProject: {
                link: "/portfolio/stacked-pilates",
                name: "Stacked Pilates"
            }
            
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        Transition1063: () => import('@/components/Transition1063'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_theWay();
            // 
            this.initImgElReveal_theWay();
            this.initTextReveal_theWay();
        }, 500)
    },
    methods: {
        initscrollSmoother_theWay() {
            this.scrollSmoother_theWay = ScrollSmoother.create({
                wrapper: '#the-way-wrapper',
                content: "#the-way",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_theWay.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_theWay() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let textAnimation_theWay = this.textAnimation_theWay;
                textAnimation_theWay = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                textAnimation_theWay.set(container, { autoAlpha: 1 });
                textAnimation_theWay.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_theWay() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_theWay = this.textAnimation_theWay;
                textAnimation_theWay = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_theWay.set(container, { autoAlpha: 1 });
                textAnimation_theWay.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_theWay.kill();
        }, 500)
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/variables';

.portfolio-page {
    .cta-section {
        background-image: url('/img/portfolio/pier/the-way-radio.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
    }

    .pier-background {
        background: url('/img/portfolio/pier/pier-color-theme.jpg') no-repeat center center; 
        background-size: cover;
    }
}


</style>